import { render, staticRenderFns } from "./SchemeTextListPage.vue?vue&type=template&id=010e3637&scoped=true&"
import script from "./SchemeTextListPage.vue?vue&type=script&lang=js&"
export * from "./SchemeTextListPage.vue?vue&type=script&lang=js&"
import style0 from "./SchemeTextListPage.vue?vue&type=style&index=0&id=010e3637&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010e3637",
  null
  
)

export default component.exports